import { useState, useEffect } from "react";
import { db } from "./firebase";
import emailjs from "emailjs-com";
import { collection, query, where, onSnapshot, addDoc } from "firebase/firestore";
import { format, addMinutes } from "date-fns";

const TIME_SLOTS = [
  "08:00", "09:30", "11:00", "12:30", "14:00",
  "15:30", "17:00", "18:30", "20:00", "21:30"
];

export default function ReservaPadel() {
  const [date, setDate] = useState(new Date());
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [reservas, setReservas] = useState([]);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fechaFormateada = format(date, "yyyy-MM-dd");
    const q = query(collection(db, "reservas"), where("fecha", "==", fechaFormateada));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const datos = snapshot.docs.map(doc => doc.data());
      setReservas(datos);
    });

    return () => unsubscribe();
  }, [date]);

  const isSlotReserved = (slot) => {
    return reservas.some((r) => r.hora === slot);
  };

  const handleReserva = async () => {
    if (!selectedSlot || !email || !nombre) return;

    const reserva = {
      nombre,
      email,
      fecha: format(date, "yyyy-MM-dd"),
      hora: selectedSlot,
    };

    try {
      await addDoc(collection(db, "reservas"), reserva);

      await emailjs.send(
        "service_go6jnaa",
        "template_p74y76o",
        {
          email: reserva.email,
          fecha: format(date, "dd/MM/yyyy"),
          hora: selectedSlot,
          nombre: reserva.nombre,
        },
        "EM6oY5qR7xQnwR6fb"
      );

      setMensaje(`✔ ¡Reserva confirmada! Se ha enviado un correo a ${reserva.email}.`);
      setSelectedSlot(null);
      setEmail("");
      setNombre("");
    } catch (error) {
      console.error("Error al guardar o enviar correo:", error);
      setMensaje("❌ Error al confirmar la reserva. Intenta de nuevo.");
    }
  };

  const getNext14Days = () => {
    const today = new Date();
    return Array.from({ length: 14 }, (_, i) => {
      const d = new Date(); d.setDate(today.getDate() + i); return d;
    });
  };

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-xl shadow max-w-2xl w-full">
        <h1 className="text-2xl font-bold text-center mb-6 text-green-700">
          Reserva tu pista en Pista de Pádel Orce
        </h1>

        <label className="block mb-1 font-semibold">Selecciona una fecha:</label>
        <select
          className="p-2 w-full border rounded mb-4"
          onChange={(e) => setDate(new Date(e.target.value))}
          value={date.toISOString().split('T')[0]}
        >
          {getNext14Days().map((d, i) => (
            <option key={i} value={d.toISOString().split('T')[0]}>
              {d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' })}
            </option>
          ))}
        </select>

        <label className="block mb-1 font-semibold">Selecciona una hora:</label>
        <div className="grid grid-cols-2 gap-2 mb-4">
          {TIME_SLOTS.map((slot) => {
            const reservado = isSlotReserved(slot);
            const seleccionado = selectedSlot === slot;
            let clases = "p-2 rounded border font-semibold ";

            if (reservado) {
              clases += "bg-red-500 text-white cursor-not-allowed opacity-70";
            } else if (seleccionado) {
              clases += "bg-green-500 text-white";
            } else {
              clases += "bg-white hover:bg-green-100";
            }

            return (
              <button
                key={slot}
                onClick={() => !reservado && setSelectedSlot(slot)}
                disabled={reservado}
                className={clases}
              >
                {slot} - {format(addMinutes(new Date("2000-01-01T" + slot), 90), "HH:mm")}
              </button>
            );
          })}
        </div>

        <label className="block mb-1 font-semibold">Tu nombre o nick:</label>
        <input
          className="p-2 w-full border rounded mb-2"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder="Tu nombre"
        />

        <label className="block mb-1 font-semibold">Tu correo electrónico:</label>
        <input
          className="p-2 w-full border rounded mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ejemplo@email.com"
        />

        <button
          className="w-full bg-green-600 hover:bg-green-700 text-white p-3 rounded font-semibold disabled:opacity-50"
          onClick={handleReserva}
          disabled={!selectedSlot || !email || !nombre}
        >
          Confirmar Reserva
        </button>

        {mensaje && <p className="mt-4 text-sm font-semibold text-green-700">{mensaje}</p>}
      </div>
    </div>
  );
}